module.exports = __webpack_public_path__ + "img/support.401595ad.png";